export enum CrewPaxTabEnum {
  CREW,
  PAX
}
